import { useLocation, useNavigate } from "react-router-dom";
import useCloudPermissions from "../../../../hooks/useCloudPermissions";
import { AppConfirm } from "../../../../utils/PopupUtil";
import DropdownOptionWithIcon from "../../../Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "../../../Menus/PopoverDropdownMenu";
import useRemoveGlobalAppFromWorkspace from "../../../../api/api-hooks/globalApps/useRemoveGlobalAppFromWorkspace";

interface Props {
  globalAppID: string;
}

export default function GlobalAppOptions({ globalAppID }: Props) {
  const { cPermissions } = useCloudPermissions();

  if (!cPermissions.cloud_modify_permissions) return null;

  return <GlobalAppOptionsPopover globalAppID={globalAppID} />;
}

function GlobalAppOptionsPopover({ globalAppID }: { globalAppID: string }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { remove, removingApp } = useRemoveGlobalAppFromWorkspace();

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="View in Store"
        icon="mdi mdi-shopping-outline"
        onClick={() => {
          navigate(
            `${pathname}?store=true&page=installed-apps&app=${globalAppID}`
          );
        }}
      />
      <DropdownOptionWithIcon
        name="Remove App"
        icon="mdi mdi-delete-outline"
        disabled={removingApp}
        onClick={handleRemoveApp}
      />
    </PopoverDropdownMenu>
  );

  async function handleRemoveApp() {
    const result = await AppConfirm({
      title: "Confirm Removal",
      html: "Are you sure you want to remove this app from the sidebar? <br /> It will still installed on this cloud if it exists. <br/> It can be readded to this workspace inside the marketplace.",
      confirmButtonText: "Remove",
    });

    if (!result.isConfirmed) return;

    remove({ globalAppID });
  }
}
